import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'product-counter',
  template: `
    <div class="flex-column justify-content-center">
      <ng-content select="[counter]"></ng-content>
      <ng-content select="[price]"></ng-content>
    </div>
    <ng-content select="[actions]"></ng-content>
  `
})
export class ProductCounterComponent {
}
